<template>
    <div>
        <CollapseConfirmData
            :codeId="code"
            @removeService="removeService"
        >
            <template #content>
                <h4 class="mb-2.5 md:mb-4">
                    此次欲申請自行繳費的保單
                </h4>

                <TableBase
                    :isDashed="true"
                    :cursorPointer="false"
                >
                    <template #thead>
                        <tr class="text-sm lg:text-base">
                            <th>
                                保單號碼
                            </th>
                            <th class="hidden sm:table-cell">
                                被保險人
                            </th>
                            <th>
                                變更前繳費方式
                            </th>
                        </tr>
                    </template>
                    <template #tbody>
                        <tr
                            v-for="(item,index) in policyList"
                            :key="index"
                            class="text-base xs:text-lg md:text-base lg:text-lg text-gray-900"
                        >
                            <td class="break-all">
                                {{ item.fullPolicyNo }}
                            </td>
                            <td class="hidden sm:table-cell">
                                {{ item.name }}
                            </td>
                            <td>
                                {{ item.payKindText }}
                            </td>
                        </tr>
                    </template>
                </TableBase>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { computed, ref, toRef } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import codeList from '@/json/codeList.js';
import TableBase from '@/components/table/TableBase.vue';

export default {
    name: 'MultiENotifyData',
    components: {
        CollapseConfirmData,
        TableBase
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref(codeList.MULTI_PAY_CHANGE);
        const policyList = computed(() => data.value.after.policyList);
        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, policyList, removeService };
    },
};
</script>
